module.exports = __webpack_public_path__ + "static/media/Stanford.7ffc7f42.png";